import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PengembanganKompetensi from 'app/KinerjaPSPegawaiPage/pages/Perencanaan/PengembanganKompetensi'
import PengembanganKompetensiV2 from 'app/KinerjaPSPegawaiPage/pages/Perencanaan/PengembanganKompetensiV2'
import PageGuardPSPegawai from 'app/KinerjaPSPegawaiPage/components/PageGuardPSPegawai'
import { usePerencanaanV2 } from 'app/KinerjaPSPegawaiPage/hooks/usePerencanaan'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-ps-pegawai-enabled'] &&
        toggle?.['kinerja-ps-pegawai-perencanaan-enabled']) ||
      false
    if (!enabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => {
  const { isPerencanaanV2 } = usePerencanaanV2()
  const PageApp = isPerencanaanV2
    ? PengembanganKompetensiV2
    : PengembanganKompetensi

  return (
    <PageGuardPSPegawai>
      <PageApp />
    </PageGuardPSPegawai>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
}

export default Page
